import type { DoctorsFilterState } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuDoctorsList/types'

/**
 * Hash для страницы врачей клиники: тот же контракт, что у ClinicDoctorsFilterMain.
 */
export default function getDoctorsFilterHash(filter: DoctorsFilterState): string {
  const query: string[] = []

  if (filter.speciality?.id) {
    query.push(`speciality=${filter.speciality.id}`)
  }

  if (filter.experience) {
    query.push(`staj=${filter.experience}`)
  }

  if (filter.gender) {
    query.push(`gender=${filter.gender}`)
  }

  if (filter.isHomeCall) {
    query.push('na_dom=true')
  }

  return query.length ? `#${query.join('&')}` : ''
}
